const initialState = {
    addressesToAutomaticAssingment: {},
    requestingAutomaticAsignmentRules: false,
    successfulAutomaticAsignmentRules: false,
    errorAutomaticAsignmentRules: false,
    allAutomaticAsignmentRules: {},
    requestingAddressesToAutomaticAssingment: false,
    successfulAddressesToAutomaticAssingment: false,
    errorAddressesToAutomaticAssingment: false,
    countAddressesToAutomaticAssingment: {},
    requestingCountAddressesToAutomaticAssingment: false,
    successfulCountAddressesToAutomaticAssingment: false,
    errorCountAddressesToAutomaticAssingment: false,
    addressesAssignedByMonth: null,
    requestingAddressesAssignedByMonth: false,
    successfulAddressesAssignedByMonth: false,
    errorAddressesAssignedByMonth: false,
    addressesPreviousWeekPieChart: null,
    requestingaddressesPreviousWeekPieChart: false,
    successfuladdressesPreviousWeekPieChart: true,
    erroraddressesPreviousWeekPieChart: false,
    switchBotAutomaticAssingment: null,
    requestingSwitchBotAutomaticAssingment: false,
    successSwitchBotAutomaticAssingment: false,
    errorSwitchBotAutomaticAssingment: false,
    StatusRecordAutomaticAssingmentByIdAddres: [],
    requestingStatusRecordAutomaticAssingment: false,
    successStatusRecordAutomaticAssingment: false,
    errorStatusRecordAutomaticAssingment: false,
    requestingDetailProgressBarToAutomaticAssingment: false,
    successfulDetailProgressBarToAutomaticAssingment: false,
    errorDetailProgressBarToAutomaticAssingment: false,
    detailProgressBarToAutomaticAssingment: null,
    requestingFailedAddressesToAutomaticAssingment: false,
    successfulFailedAddressesToAutomaticAssingment: false,
    errorFailedAddressesToAutomaticAssingment: false,
    failedAddressesToAutomaticAssingment: null,
}

const addressToAutomaticAssigmentReducer = (state = initialState, payload) => {
    switch (payload.type) {
        case "FETCHING_ALL_AUTOMATIC_ASSIGMENT_RULES":
            return {
                ...state,
                requestingAutomaticAsignmentRules: true,
                successfulAutomaticAsignmentRules: false,
                errorAutomaticAsignmentRules: false,
            };
        case "ALL_AUTOMATIC_ASSIGMENT_RULES_SUCCESS":
            return {
                ...state,
                requestingAutomaticAsignmentRules: false,
                successfulAutomaticAsignmentRules: true,
                errorAutomaticAsignmentRules: false,
                allAutomaticAsignmentRules: payload.value,
            };
        case "ALL_AUTOMATIC_ASSIGMENT_RULES_ERROR":
            return {
                ...state,
                requestingAutomaticAsignmentRules: false,
                successfulAutomaticAsignmentRules: false,
                errorAutomaticAsignmentRules: true,
            };
        case "RESET_ALL_AUTOMATIC_ASSIGMENT_RULES":
            return {
                ...state,
                requestingAutomaticAsignmentRules: false,
                successfulAutomaticAsignmentRules: false,
                errorAutomaticAsignmentRules: false,
                allAutomaticAsignmentRules: {},
            };
        case "FETCHING_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT":
            return {
                ...state,
                requestingAddressesToAutomaticAssingment: true,
                successfulAddressesToAutomaticAssingment: false,
                errorAddressesToAutomaticAssingment: false,
            };
        case "ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_SUCCESS":
            return {
                ...state,
                requestingAddressesToAutomaticAssingment: false,
                successfulAddressesToAutomaticAssingment: true,
                errorAddressesToAutomaticAssingment: false,
                addressesToAutomaticAssingment: payload.value,
            };
        case "ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_ERROR":
            return {
                ...state,
                requestingAddressesToAutomaticAssingment: false,
                successfulAddressesToAutomaticAssingment: false,
                errorAddressesToAutomaticAssingment: true,
            };
        case "FETCHING_ALL_FAILED_ADDRESSES_TO_AUTOMATIC_ASSIGMENT":
            return {
                ...state,
                requestingFailedAddressesToAutomaticAssingment: true,
                successfulFailedAddressesToAutomaticAssingment: false,
                errorFailedAddressesToAutomaticAssingment: false,
            };
        case "ALL_FAILED_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_SUCCESS":
            return {
                ...state,
                requestingFailedAddressesToAutomaticAssingment: false,
                successfulFailedAddressesToAutomaticAssingment: true,
                errorFailedAddressesToAutomaticAssingment: false,
                failedAddressesToAutomaticAssingment: payload.value,
            };
        case "ALL_FAILED_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_ERROR":
            return {
                ...state,
                requestingFailedAddressesToAutomaticAssingment: false,
                successfulFailedAddressesToAutomaticAssingment: false,
                errorFailedAddressesToAutomaticAssingment: true,
            };
        case "RESET_ALL_FAILED_ADDRESSES_TO_AUTOMATIC_ASSIGMENT":
            return {
                ...state,
                requestingFailedAddressesToAutomaticAssingment: false,
                successfulFailedAddressesToAutomaticAssingment: false,
                errorFailedAddressesToAutomaticAssingment: false,
                failedAddressesToAutomaticAssingment: {},
            };
        case "RESET_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT":
            return {
                ...state,
                requestingAddressesToAutomaticAssingment: false,
                successfulAddressesToAutomaticAssingment: false,
                errorAddressesToAutomaticAssingment: false,
                addressesToAutomaticAssingment: {},
            };

        case "FETCHING_ALL_COUNT_ADDRESSES_TO_AUTOMATIC_ASSIGMENT":
            return {
                ...state,
                requestingCountAddressesToAutomaticAssingment: true,
                successfulCountAddressesToAutomaticAssingment: false,
                errorCountAddressesToAutomaticAssingment: false,
            };
        case "COUNT_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_SUCCESS":
            return {
                ...state,
                requestingCountAddressesToAutomaticAssingment: false,
                successfulCountAddressesToAutomaticAssingment: true,
                errorCountAddressesToAutomaticAssingment: false,
                countAddressesToAutomaticAssingment: payload.value,
            };
        case "COUNT_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_ERROR":
            return {
                ...state,
                requestingCountAddressesToAutomaticAssingment: false,
                successfulCountAddressesToAutomaticAssingment: false,
                errorCountAddressesToAutomaticAssingment: true,
            };
        case "RESET_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_COUNT":
            return {
                ...state,
                requestingCountAddressesToAutomaticAssingment: false,
                successfulCountAddressesToAutomaticAssingment: false,
                errorCountAddressesToAutomaticAssingment: false,
                countAddressesToAutomaticAssingment: {},
            };

        case "FETCHING_DETAIL_PROGRESS_BAR_TO_AUTOMATIC_ASSIGMENT":
            return {
                ...state,
                requestingDetailProgressBarToAutomaticAssingment: true,
                successfulDetailProgressBarToAutomaticAssingment: false,
                errorDetailProgressBarToAutomaticAssingment: false,
            };
        case "DETAIL_PROGRESS_BAR_TO_AUTOMATIC_ASSIGMENT_SUCCESS":
            return {
                ...state,
                requestingDetailProgressBarToAutomaticAssingment: false,
                successfulDetailProgressBarToAutomaticAssingment: true,
                errorDetailProgressBarToAutomaticAssingment: false,
                detailProgressBarToAutomaticAssingment: payload.value,
            };
        case "DETAIL_PROGRESS_BAR_TO_AUTOMATIC_ASSIGMENT_ERROR":
            return {
                ...state,
                requestingDetailProgressBarToAutomaticAssingment: false,
                successfulDetailProgressBarToAutomaticAssingment: false,
                errorDetailProgressBarToAutomaticAssingment: true,
            };

        case "COUNT_ASSIGNED_ADDRESSES_BY_MONTH_REQUESTING":
            return {
                ...state,
                requestingAddressesAssignedByMonth: true,
                successfulAddressesAssignedByMonth: false,
                errorAddressesAssignedByMonth: false,
            }
        case "COUNT_ASSIGNED_ADDRESSES_BY_MONTH_SUCCESS":
            return {
                ...state,
                addressesAssignedByMonth: payload.value,
                requestingAddressesAssignedByMonth: false,
                successfulAddressesAssignedByMonth: true,
                errorAddressesAssignedByMonth: false,
            }
        case "COUNT_ASSIGNED_ADDRESSES_BY_MONTH_ERROR":
            return {
                ...state,
                requestingAddressesAssignedByMonth: false,
                successfulAddressesAssignedByMonth: false,
                errorAddressesAssignedByMonth: true,
            }
        case "COUNT_ASSIGNED_ADDRESSES_BY_MONTH_RESET":
            return {
                ...state,
                addressesAssignedByMonth: null,
                requestingAddressesAssignedByMonth: false,
                successfulAddressesAssignedByMonth: false,
                errorAddressesAssignedByMonth: false,
            }
        
        case "ADDRESS_PREVIOUS_WEEK_PIE_CHART_REQUESTING":
            return {
                ...state,
                requestingAddressesPreviousWeekPieChart: true,
                successfulAddressesPreviousWeekPieChart: false,
                errorAddressesPreviousWeekPieChart: false,
            }
        case "ADDRESS_PREVIOUS_WEEK_PIE_CHART_SUCCESS":
            return {
                ...state,
                addressesPreviousWeekPieChart: payload.value,
                requestingAddressesPreviousWeekPieChart: false,
                successfulAddressesPreviousWeekPieChart: true,
                errorAddressesPreviousWeekPieChart: false,
            }
        case "ADDRESS_PREVIOUS_WEEK_PIE_CHART_ERROR":
            return {
                ...state,
                requestingAddressesPreviousWeekPieChart: false,
                successfulAddressesPreviousWeekPieChart: false,
                errorAddressesPreviousWeekPieChart: true,
            }
        
        case "SWITCH_BOT_AUTOMATIC_ASIGMENT_REQUESTING":
            return {
                ...state,
                requestingSwitchBotAutomaticAssingment: true,
                successfulSwitchBotAutomaticAssingment: false,
                errorSwitchBotAutomaticAssingment: false,
            };
        case "SWITCH_BOT_AUTOMATIC_ASIGMENT_SUCCESS":
            return {
                ...state,
                requestingSwitchBotAutomaticAssingment: false,
                successfulSwitchBotAutomaticAssingment: true,
                errorSwitchBotAutomaticAssingment: false,
                switchBotAutomaticAssingment: payload.value
            };
        case "SWITCH_BOT_AUTOMATIC_ASIGMENT_ERROR":
            return {
                ...state,
                requestingSwitchBotAutomaticAssingment: false,
                successSwitchBotAutomaticAssingment: false,
                errorSwitchBotAutomaticAssingment: true,
            };
        case "RESET_BOT_AUTOMATIC_ASIGMENT":
            return {
                ...state,
                requestingSwitchBotAutomaticAssingment: false,
                successSwitchBotAutomaticAssingment: false,
                errorSwitchBotAutomaticAssingment: false,
                switchBotAutomaticAssingment: null,
            };
        case "GET_STATUS_RECORD_AUTOMATIC_ASIGMENT_REQUESTING":
            return {
                ...state,
                requestingStatusRecordAutomaticAssingment: true,
                successStatusRecordAutomaticAssingment: false,
                errorStatusRecordAutomaticAssingment: false,
            };
        case "GET_STATUS_RECORD_AUTOMATIC_ASIGMENT_SUCCESS":
            return {
                ...state,
                requestingStatusRecordAutomaticAssingment: false,
                successStatusRecordAutomaticAssingment: true,
                errorStatusRecordAutomaticAssingment: false,
                StatusRecordAutomaticAssingmentByIdAddres: payload.value
            };
        case "GET_STATUS_RECORD_AUTOMATIC_ASIGMENT_ERROR":
            return {
                ...state,
                requestingStatusRecordAutomaticAssingment: false,
                successStatusRecordAutomaticAssingment: false,
                errorStatusRecordAutomaticAssingment: true,
            };
        case "RESET_STATUS_RECORD_AUTOMATIC_ASSIGNMENT":
            return {
                ...state,
                requestingStatusRecordAutomaticAssingment: false,
                successStatusRecordAutomaticAssingment: false,
                errorStatusRecordAutomaticAssingment: false,
                StatusRecordAutomaticAssingmentByIdAddres: [],
            };
        default:
            return state;
    };
}

export default addressToAutomaticAssigmentReducer;